/**
 * 支付结果提示
 */
import React, {Component} from 'react';
import Cache from 'c-cache';
import Modal from 'boron/ScaleModal';
import lang from '../../lang';
import PayResult from '../../component/recharge/payresult';
import bindPhoneGuid from '../bindphone-guid';
import FrozenConfirm from './frozen';

const cache = new Cache({
	prefix: 'pcuplive'
});


const style = {
    modalStyle: {
         width: '320px',
         zIndex: 1070
    },
    contentStyle: {
        width: '320px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        outline: 0,
    },
    backdropStyle: {
        backgroundColor: "rgba(0,0,0, 0.5)",
        zIndex: 1060
    }
}

class RechargeResult extends Component {
	constructor(props) {
		super(props);

		this.state = {
			paySuccess: 0,
			diamond: 0
		}
	}

	componentDidMount() {
		let paid = cache.getCache('_u_paid');
		let orderId = cache.getCache('_u_orderId_' + paid);
		let channel = cache.getCache('_u_paid_channel');
		let paidret = cache.getCache('_u_paidret');
		
		if (orderId) {
			// 回调地址已知道结果
			if (paidret) {
				let arr = paidret.split('/');
				
				if (arr.length == 2 && arr[0] == paid) {
					if (arr[1] == 1) {
						this.showResultSuccess();	
					} else if(arr[1] == 0) {
						this.showResultError();
					}
				}
			} else {
				if (channel == 'icard') {
					this.refs.warn.show();
				} else {	
					var checkCount = 0;
					var timer;
					var checkFun = (orderId)=>{
						timer && clearTimeout(timer);

						var verifyOrder = new PayResult(orderId);

						verifyOrder.promise.done((resp)=>{
			                this.showResultSuccess();
			            }).fail(()=>{
			            	checkCount++;
			            	
			            	if (checkCount <= 4) {
			            		timer = setTimeout(()=>{
			            			checkFun(orderId);
			            		}, 2 * 1000);
			            	} else {
			            		this.showResultError();
			            	}
			            });
					}

					checkFun(orderId);
				}
			}

            cache.removeCache('_u_paid');
            cache.removeCache('_u_paidret');
            cache.removeCache('_u_paid_channel');
			cache.removeCache('_u_orderId_' + paid);
		}

	}

	showResultSuccess(){
		UP.Global.DA.add({
            eventName: 'UplivePayment',
            action: 'Payment Successful',
            label: 'success'           
        });
        UP.Global.DA.add({
            eventName: 'UplivePaymentSuccessful',
            action: 'click'
        });
		this.refs.success.show();
	}

	showResultError (code){

		if (code == 12323) {
			FrozenConfirm.show();
		} else {
			this.refs.error.show();
		}
	}

	hideResultSuccess(){
		this.refs.success.hide();
		
		setTimeout(()=>{
			let userInfo = UP.Global.getUser();
			let hasBindMobilePhone = userInfo.mobilePhone ? true : false;
			
			if (!hasBindMobilePhone) {
				bindPhoneGuid.show();	
			}
		}, 300);
	}
	
	hideResultError () {
		this.refs.error.hide();
	}

	hideResultWarn () {
		this.refs.warn.hide();
	}
	
	render() {
		return (
			<div>
				<Modal 
	                ref="success" 
	                modalStyle={style.modalStyle}  
	                backdropStyle={style.backdropStyle} 
	                contentStyle={style.contentStyle}
	            >
					<div className="recharge-result">
						<div className="recharge-result-hd">{  lang.template('提示') }</div>
						<div className="recharge-result-bd">{  lang.template('充值成功') }</div>
						<div className="recharge-result-ft">
	                        <button className="btn confirm" onClick={()=>this.hideResultSuccess()}>{lang.template('确认')}</button>
	                    </div>
                	</div>
				</Modal>
				<Modal 
	                ref="error"
	                modalStyle={style.modalStyle}  
	                backdropStyle={style.backdropStyle} 
	                contentStyle={style.contentStyle}
	            >
	            	<div className="recharge-result">
						<div className="recharge-result-hd">{  lang.template('提示') }</div>
						<div className="recharge-result-bd">{  lang.template('支付失败，请重新下单') }</div>
						<div className="recharge-result-ft">
	                        <button className="btn confirm" onClick={()=>this.hideResultError()}>{lang.template('确认')}</button>
	                    </div>
                	</div>
				</Modal>

				<Modal 
	                ref="warn"
	                modalStyle={style.modalStyle}  
	                backdropStyle={style.backdropStyle} 
	                contentStyle={style.contentStyle}
	            >
	            	<div className="recharge-result">
						<div className="recharge-result-hd">{  lang.template('提示') }</div>
						<div className="recharge-result-bd">{  lang.template('Giao dịch thành công, thanh toán này sẽ xử lý 5-10 phút.') }</div>
						<div className="recharge-result-ft">
	                        <button className="btn confirm" onClick={()=>this.hideResultWarn()}>{lang.template('确认')}</button>
	                    </div>
                	</div>
				</Modal>
			</div>
		);
	}	
}

export default RechargeResult;


// WEBPACK FOOTER //
// ./js/mall/recharge-result/index.js